// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__326f2","upload":"Small_upload__2osPt","imageWrap":"Small_imageWrap__MsLY8","removeBtn":"Small_removeBtn__1arWk"};